var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-agent-page-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "section" }, [
        _c(
          "div",
          { staticClass: "toolbar-container" },
          [
            _c("CallHistoryFilterToolbar", {
              ref: "filterToolbar",
              attrs: { "status-list": [] },
              model: {
                value: _vm.filters,
                callback: function ($$v) {
                  _vm.filters = $$v
                },
                expression: "filters",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toolbar-group" },
              [
                _c(
                  "div",
                  { staticClass: "simple-pagination" },
                  [
                    _c("a-button", {
                      attrs: {
                        icon: "double-left",
                        disabled: _vm.currentPage <= 1 || _vm.loading,
                      },
                      on: { click: _vm.firstPage },
                    }),
                    _vm._v(" "),
                    _c("a-button", {
                      attrs: {
                        icon: "left",
                        disabled: _vm.currentPage <= 1 || _vm.loading,
                      },
                      on: { click: _vm.previousPage },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "page-number" }, [
                      _vm._v(_vm._s(_vm.currentPage)),
                    ]),
                    _vm._v(" "),
                    _c("a-button", {
                      attrs: {
                        icon: "right",
                        disabled: !_vm.hasNextPage || _vm.loading,
                      },
                      on: { click: _vm.nextPage },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "toolbar-button",
                    on: { click: _vm.showCustomizeColumnsModal },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("settings"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Customize Field")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", icon: "export" },
                    on: { click: _vm.exportData },
                  },
                  [_vm._v(" Export ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "table-wrapper" },
          [
            _c(
              "a-spin",
              { attrs: { spinning: _vm.loading } },
              [
                _c("SupsisTable", {
                  attrs: {
                    columns: _vm.getTableColumns(),
                    rows: _vm.calls,
                    options: {
                      rowStyleOption: { stripe: true },
                      rowKeyFieldName: "call_id",
                      fixedHeader: true,
                      borderX: true,
                      borderY: true,
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Arama Detayları",
            width: "1000px",
            footer: null,
            bodyStyle: { maxHeight: "calc(100vh - 200px)", overflowY: "auto" },
          },
          on: { cancel: _vm.closeTranscriptModal },
          model: {
            value: _vm.transcriptModalVisible,
            callback: function ($$v) {
              _vm.transcriptModalVisible = $$v
            },
            expression: "transcriptModalVisible",
          },
        },
        [
          _vm.selectedCall
            ? _c("div", [
                _c("div", { staticClass: "call-details" }, [
                  _c("div", { staticClass: "call-info" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Call ID:")]),
                      _vm._v(" " + _vm._s(_vm.selectedCall.call_id)),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("strong", [_vm._v("Time:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(_vm.selectedCall.start_timestamp)
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("strong", [_vm._v("Duration:")]),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.formatDuration(
                              _vm.selectedCall.start_timestamp,
                              _vm.selectedCall.end_timestamp
                            )
                          ) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("strong", [_vm._v("From:")]),
                      _vm._v(" " + _vm._s(_vm.selectedCall.from_number)),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("strong", [_vm._v("To:")]),
                      _vm._v(" " + _vm._s(_vm.selectedCall.to_number)),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("strong", [_vm._v("Status:")]),
                      _vm._v(" " + _vm._s(_vm.selectedCall.call_status)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "transcript-container" }, [
                    _c("h3", [_vm._v("Transcript")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "transcript-content" },
                      _vm._l(_vm.transcriptItems, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: [
                              "transcript-item",
                              "transcript-" + item.role,
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.seekToTranscriptItem(item, index)
                              },
                            },
                          },
                          [
                            item.role === "user"
                              ? [
                                  _c("div", { staticClass: "message-header" }, [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("person"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "role-label" }, [
                                      _vm._v("Kullanıcı"),
                                    ]),
                                    _vm._v(" "),
                                    item.words && item.words.length
                                      ? _c(
                                          "span",
                                          { staticClass: "time-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatSeconds(
                                                  item.words[0].start
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "message-content" },
                                    [_vm._v(_vm._s(item.content))]
                                  ),
                                ]
                              : item.role === "agent"
                              ? [
                                  _c("div", { staticClass: "message-header" }, [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("smart_toy"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "role-label" }, [
                                      _vm._v("Ajan"),
                                    ]),
                                    _vm._v(" "),
                                    item.words && item.words.length
                                      ? _c(
                                          "span",
                                          { staticClass: "time-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatSeconds(
                                                  item.words[0].start
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "message-content" },
                                    [_vm._v(_vm._s(item.content))]
                                  ),
                                ]
                              : item.role === "tool_call_invocation"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "tool-call-box invocation" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tool-call-header" },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getToolIcon(item.type)
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "tool-name" },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-tag",
                                            {
                                              attrs: {
                                                color: _vm.getToolTypeColor(
                                                  item.type
                                                ),
                                                size: "small",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getToolTypeText(item.type)
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "time-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatSeconds(
                                                    item.time_sec
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.getAutomationLink(item)
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "automation-link",
                                                  attrs: {
                                                    href: _vm.getAutomationLink(
                                                      item
                                                    ),
                                                    target: "_blank",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("open_in_new")]
                                                  ),
                                                  _vm._v(
                                                    "\n                                            Otomasyonu Düzenle\n                                        "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      item.arguments
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tool-call-arguments",
                                            },
                                            [
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatToolArguments(
                                                      item.arguments
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              : item.role === "tool_call_result"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tool-call-box result",
                                      class: {
                                        success: item.successful,
                                        error: !item.successful,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tool-call-header" },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.successful
                                                    ? "check_circle"
                                                    : "error"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "result-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.successful
                                                    ? "Başarılı"
                                                    : "Hata"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "time-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatSeconds(
                                                    item.time_sec
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.content
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "tool-call-content",
                                            },
                                            [
                                              _c("pre", [
                                                _vm._v(_vm._s(item.content)),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.$_.get(_vm.selectedCall, "call_analysis.call_summary")
                    ? _c("div", { staticClass: "call-summary" }, [
                        _c("h3", [_vm._v("Call Summary")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$_.get(
                                _vm.selectedCall,
                                "call_analysis.call_summary"
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCall.recording_url
                    ? _c("div", { staticClass: "audio-player" }, [
                        _c("h3", [_vm._v("Recording")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modern-audio-player" }, [
                          _c("div", { staticClass: "audio-player-info" }, [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons audio-icon pulse",
                              },
                              [_vm._v("music_note")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "audio-title-container" },
                              [
                                _c("div", { staticClass: "audio-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.selectedCall.start_timestamp
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "audio-player-wrapper" }, [
                            _c("audio", {
                              ref: "transcriptAudioPlayer",
                              staticStyle: { width: "100%" },
                              attrs: {
                                controls: "",
                                src: _vm.selectedCall.recording_url,
                              },
                            }),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Customize Fields",
            okText: "Kaydet",
            cancelText: "İptal",
          },
          on: { ok: _vm.saveColumnSettings },
          model: {
            value: _vm.customizeColumnsModalVisible,
            callback: function ($$v) {
              _vm.customizeColumnsModalVisible = $$v
            },
            expression: "customizeColumnsModalVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "customize-columns-container" },
            _vm._l(_vm.availableColumns, function (column) {
              return _c(
                "div",
                {
                  key: column.key,
                  staticClass: "column-option",
                  on: {
                    click: function ($event) {
                      return _vm.toggleColumnVisibility(column.key)
                    },
                  },
                },
                [
                  _c("a-switch", {
                    attrs: {
                      checked: _vm.columnVisibility[column.key],
                      disabled:
                        column.key === "time" || column.key === "actions",
                    },
                    on: {
                      change: function (checked) {
                        return _vm.onSwitchChange(column.key, checked)
                      },
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "column-label" }, [
                    _vm._v(_vm._s(column.title)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showAudioPlayer
        ? _c("div", { staticClass: "audio-player-dock" }, [
            _c("div", { staticClass: "audio-player-container" }, [
              _c("div", { staticClass: "audio-player-info" }, [
                _c("i", { staticClass: "material-icons audio-icon pulse" }, [
                  _vm._v("music_note"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "audio-title-container" }, [
                  _c("div", { staticClass: "now-playing" }, [
                    _vm._v("Şimdi Çalıyor"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "audio-title" }, [
                    _vm._v(_vm._s(_vm.currentPlayingRecordName)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "audio-player-wrapper" }, [
                _c("audio", {
                  ref: "audioPlayer",
                  attrs: {
                    controls: "",
                    src: _vm.currentPlayingRecordURL,
                    autoplay: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "audio-player-controls" },
                [
                  _c("a-button", {
                    attrs: {
                      type: "danger",
                      shape: "circle",
                      icon: "close",
                      size: "large",
                    },
                    on: { click: _vm.closeAudioPlayer },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-section" }, [
      _c("div", { staticClass: "title-wrapper" }, [
        _c("h1", { staticClass: "main-title" }, [_vm._v("Arama Geçmişi")]),
        _vm._v(" "),
        _c("p", { staticClass: "title-description" }, [
          _vm._v(
            "\n                Bu sayfada ses ajanları tarafından yapılan aramaların geçmişini görüntüleyebilirsiniz\n            "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }